<p class="statement">
  <span class="asterisk">*</span>
  Stay in the loop! By registering, you're signing up to receive exciting
  updates, exclusive offers, and valuable content via email. Don't miss out on
  the latest news and promotions – join our community today!
</p>
